import { useEffect, useState } from "react";
import ContentContainer from "../components/ContentContainer";
import { patchAdmin, resetDatabase } from "../services/adminService";
import { fetchGroup } from "../services/groupService";
import {
  exportData,
  exportOneGroup,
  importData,
} from "../services/dataService";
import { useFeedback } from "../Contexts/FeedbackContext";
import {
  SUCCESS_IMPORT,
  ERROR_IMPORT,
  ERROR_EXPORT,
  WRONG_PASSWORD,
  SUCCESS_UPDATE,
  ERROR_UPDATE,
  SUCCESS_RESET,
  ERROR_RESET,
} from "../constants/feedbacks";
import { PROMPT_DELETE_ALL_DATA } from "../constants/prompts";

export default function AdminPage() {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [file, setFile] = useState(null);
  const { showFeedback } = useFeedback();
  const [group, setGroup] = useState(null);
  const [groupList, setGroupList] = useState([]);

  function handleImport() {
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    importData(formData)
      .then(() => showFeedback(SUCCESS_IMPORT, true))
      .catch(() => {
        showFeedback(ERROR_IMPORT, false);
      });
  }

  async function handleExport() {
    try {
      const response = await exportData();

      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });
      const fileName = `students_export_${
        new Date().toISOString().split("T")[0]
      }.xlsx`;

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      link.style.display = "none";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setTimeout(() => window.URL.revokeObjectURL(url), 100);
    } catch {
      showFeedback(ERROR_EXPORT, false);
    }
  }

  async function handleExportGroup() {
    if (!group) {
      return;
    }
    try {
      const response = await exportOneGroup(group.id);

      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });
      const fileName = `${group.name}_export_${
        new Date().toISOString().split("T")[0]
      }.xlsx`;

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      link.style.display = "none";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setTimeout(() => window.URL.revokeObjectURL(url), 100);
    } catch {
      showFeedback(ERROR_EXPORT, false);
    }
  }
  useEffect(() => {
    fetchGroup()
      .then((data) => {
        const groupEntries = Object.entries(data.data);
        const groupsArray = groupEntries.map(([name, group]) => ({
          id: group.id,
          name,
        }));
        setGroupList(groupsArray);
      })
      .catch(console.error);
  }, []);

  function handleSubmit(e) {
    e.preventDefault();
    const body = {
      newPassword: newPassword,
      currentPassword: currentPassword,
    };
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_]).{8,}$/;

    if (!passwordRegex.test(newPassword)) {
      alert(
        "Le mot de passe doit répondre aux critères suivants :\n" +
          "- Au moins 8 caractères\n" +
          "- Au moins une lettre majuscule ([A-Z])\n" +
          "- Au moins une lettre minuscule ([a-z])\n" +
          "- Au moins un chiffre ([0-9])\n" +
          "- Au moins un caractère spécial (!@#$%^&*()_)"
      );
      return;
    }
    patchAdmin(body)
      .then(() => {
        showFeedback(SUCCESS_UPDATE, true);
      })
      .catch((err) => {
        if (err.status === 403) showFeedback(WRONG_PASSWORD, false);
        else {
          showFeedback(ERROR_UPDATE, false);
        }
        console.error(err);
      });
  }

  async function handleReset() {
    if (window.confirm(PROMPT_DELETE_ALL_DATA)) {
      resetDatabase()
        .then((res) => showFeedback(SUCCESS_RESET, true))
        .catch((err) => showFeedback(ERROR_RESET, false));
    }
  }
  return (
    <>
      <ContentContainer>
        <h2 className="text-xl font-bold mb-4">Compte</h2>
        <form>
          <div className="mb-2">
            <label htmlFor="password" className="mr-2">
              Mot de passe actuel
            </label>
            <input
              id="password"
              type="password"
              className="border flex-1 p-1"
              onChange={(e) => setCurrentPassword(e.target.value)}
              value={currentPassword}
            />
          </div>

          <div>
            <label htmlFor="newPassword" className="mr-2">
              Nouveau mot de passe
            </label>
            <input
              id="newPassword"
              type="password"
              className="border flex-1 p-1"
              onChange={(e) => setNewPassword(e.target.value)}
              value={newPassword}
            />
          </div>
          <button
            type="submit"
            onClick={handleSubmit}
            className="bg-primary-blue hover:bg-tertiary-blue p-2 rounded text-white"
          >
            Valider
          </button>
        </form>
        <hr className="my-5" />
        <h2 className="text-xl font-bold mb-4">Import/export</h2>
        <div className="gap-3 flex flex-col items-start">
          <label htmlFor="importFile" className="mb-2">
            Sélectionner le fichier à importer
          </label>
          <input
            id="importFile"
            type="file"
            accept=".xlsx"
            className="border border-gray-300 rounded-md px-1 py-1 text-gray-700 hover:border-gray-600"
            onChange={(e) => setFile(e.target.files[0])}
          />
          <button
            type="button"
            onClick={handleImport}
            className="bg-primary-blue hover:bg-tertiary-blue p-2 rounded text-white"
          >
            Importer les élèves
          </button>
        </div>
        <hr className="my-5" />
        <button
          type="button"
          onClick={handleExport}
          className="bg-primary-blue hover:bg-tertiary-blue p-2 rounded text-white"
        >
          Exporter tous les élèves
        </button>

        <hr className="my-5" />
        <div className="gap-3 flex flex-row items-start">
          <label htmlFor="selectGroup" className="sr-only" />
          <select
            id="selectGroup"
            name="groups"
            onChange={(e) => {
              const selectedId = e.target.value;
              const selectedGroup = groupList.find(
                (g) => g.id.toString() === selectedId
              );
              setGroup(selectedGroup || null);
            }}
            className="border border-gray-300 rounded-md px-3 py-2 text-gray-700 hover:border-gray-600"
          >
            <option value="">--Choisir un groupe--</option>
            {groupList.map((group) => (
              <option value={group.id} key={group.id}>
                {group.name}
              </option>
            ))}
          </select>
          <button
            type="button"
            onClick={handleExportGroup}
            className="bg-primary-blue hover:bg-tertiary-blue p-2 rounded text-white"
          >
            Exporter le groupe
          </button>
        </div>

        <hr className="my-5" />
        <h2 className="text-xl font-bold mb-4">Données</h2>

        <button
          className="bg-primary-danger hover:bg-secondary-danger p-2 rounded text-white"
          onClick={handleReset}
        >
          Effacer toutes les données
        </button>
      </ContentContainer>
    </>
  );
}
